
export type TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetType = typeof TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetType[keyof typeof TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetType = {
  REPLIED_TO: 'REPLIED_TO',
  QUOTED: 'QUOTED',
  RETWEETED: 'RETWEETED',
} as const;
